export default __webpack_public_path__ + "static/media/zlc-financial-black.4d722a4c.png";